import { useState, useEffect, useRef, Fragment, useContext } from 'react'
import Image from 'next/image'
import Router from 'next/router'
import { Button, Modal } from 'antd'
// import numeral from 'numeral'
import { FormattedMessage, injectIntl } from 'react-intl'
import { getEnv } from '@/utils/index.js';


import _ from 'lodash'

import myContext from '@/utils/createContext'

const LinkPay = props => {
    const [nextLink, setNextLink] = useState('');
    const {
        intl,
        type,
        loading,
        setLoading,
        actualPaymentAmount,
        actualPaymentCurrency,
        redirectUrl,
        key
    } = useContext(myContext)
    const [origin, setOrigin] = useState('')


    const { formatMessage } = intl;


    useEffect(() => {
        // 获取跳转链接
        setOrigin(window?.location?.origin)
    }, [])

    const renderText = () => { 
        return (<>
            <p style={{textAlign: 'center'}}>
                <FormattedMessage id={`evonet.${type}.link.tip`} />
            </p>
            <div className='product-pay-icon-space'>
                {/* 兼容线上图片文件名大小写 */}
                <Image src={`/static/images/evonet/${type}.svg`} alt={type} width={141} height={46} />           
            </div>
        </>
        )
    }

    return (
        <div>
            <div className='product-text-666'>
                { renderText()}
            </div>
            <div className="h5pc-submit">
                <Button
                    className="h5pc-submit-btn"
                    type="primary"
                    onClick={() => {
                        setLoading(true)                        
                        window.location.href = redirectUrl
                    }}
                    loading={loading}
                >

                    <span className="lock-img" ></span>
                    {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
                    {actualPaymentAmount} {actualPaymentCurrency}
                </Button>
            </div>
        </div>
    )
}

export default injectIntl(LinkPay)
